const serviceWorkerPath = new URL(`./sw.ts`, import.meta.url);
const serviceWorkerFilename = (serviceWorkerPath + "").split("/").pop();
const pathname = window.location.pathname;
const isDev = process.env.NODE_ENV === "development";

const fullPath =
  pathname[pathname.length - 1] === "/"
    ? pathname.slice(0, pathname.length - 1)
    : pathname;
const isSwInstalled =
  localStorage.getItem(`sw-installed-${process.env.SW_CACHE_NAME}`) === "true";

export async function registerServiceWorker() {
  if (
    !("serviceWorker" in navigator) ||
    window.top !== window.self ||
    !serviceWorkerFilename ||
    isDev
  ) {
    // don't instantiate service worker:
    // [1] if service worker isn't supported
    // [2] in iframes
    // [3] if there is no service worker file
    // [4] in development mode
    return;
  }

  try {
    const registration = await navigator.serviceWorker.register(
      fullPath + "/" + serviceWorkerFilename,
      {
        // type: "module",
        scope: fullPath + "/",
      },
    );

    // Force an update check
    await registration.update();

    // Listen for updates to the service worker
    registration.onupdatefound = () => {
      console.log("Service worker update found...");
      const newWorker = registration.installing;
      if (newWorker) {
        console.log("A new service worker is being installed...");

        newWorker.onstatechange = () => {
          if (newWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              // New update available
              console.log("New service worker installed. Activating...");
              newWorker.postMessage({ action: "skipWaiting" });
            } else {
              console.log("Service worker installed for the first time.");
            }
          }
        };
      } else {
        console.log("No new service worker found...");
      }
    };

    // Automatically reload the page when the new service worker takes over
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      console.log("New service worker activated. Reloading the page...");
      window.location.reload();
    });
  } catch (error) {
    console.error(`Registration failed with ${error}`);
  }
}
